import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
const logo = require('../images/ORANIUM_LOGO.webp');

const Header = ({ onCourseSelect, onEnrollClick, activePage = 'home', onHomeClick, onAboutClick, onContactClick, selectedCourse, onMobileMenuToggle }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isCoursesDropdownOpen, setIsCoursesDropdownOpen] = useState(false);
  const [selectedMobileCategory, setSelectedMobileCategory] = useState(null);
  const [showPromoBanner, setShowPromoBanner] = useState(true);
  const [promoIndex, setPromoIndex] = useState(0);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const dropdownCloseTimer = React.useRef(null);
  const scrollPosition = React.useRef(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const promoMessages = [
    '🎉 Special Offer: Get 20% OFF on all courses! Limited time only. Enroll Now!',
    '🚀 New Batch Starting Soon! Join our expert-led training programs today!',
    '💼 100% Job Assistance! Get placed in top IT companies with our support!',
    '⭐ Rated 4.9/5 by 1000+ Students! Transform your career with us!'
  ];

  const mobilePromoMessages = [
    '🎉 20% OFF - Limited Time!',
    '🚀 New Batch Starting Soon!',
    '💼 100% Job Assistance!',
    '⭐ Rated 4.9/5 by 1000+ Students!'
  ];

  React.useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  React.useEffect(() => {
    const interval = setInterval(() => {
      setPromoIndex((prev) => (prev + 1) % promoMessages.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (isMobileMenuOpen) {
      scrollPosition.current = window.scrollY;
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      if (window.Tawk_API?.hideWidget) window.Tawk_API.hideWidget();
    } else {
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
      if (window.Tawk_API?.showWidget) window.Tawk_API.showWidget();
    }
  }, [isMobileMenuOpen]);

  useEffect(() => {
    if (!isCoursesDropdownOpen) {
      setSelectedCategory(null);
    }
  }, [isCoursesDropdownOpen]);

  const courseCategories = {
    'trending-courses': {
      name: 'Trending Courses',
      courses: [
        'Artificial Intelligence & Gen-AI',
        'Prompt Engineering',
        'Cloud Computing',
        'DevOps & SRE',
        'Software Testing',
        'Data Analytics',
        'Data Engineering',
        'Full-Stack Development',
        'Power Platform / Low-Code Automation',
        'Data Science',
        'UI/UX Design'
      ]
    },
    'ai-section': {
      name: 'Artificial Intelligence',
      courses: [
        'Data Science with Gen-AI Training',
        'Generative AI Training',
        'Prompt Engineering Training',
        'Agentic AI Training',
        'Machine Learning Training',
        'Microsoft Copilot Training',
        'AI in Project Management Training',
        'AI in Excel Training',
        'AI Business Analyst Training',
        'AI Chatbot Development Training'
      ]
    },
    'software-testing': {
      name: 'Software Testing',
      courses: [
        'Selenium Automation Training (Java/Python/C#)',
        'Cypress Automation Training (JavaScript)',
        'Playwright Automation Training (TypeScript)',
        'API Testing Training (Postman + RestAssured)',
        'Performance Testing Training (JMeter)',
        'Mobile Automation Training (Appium)'
      ]
    },
    'cloud-computing': {
      name: 'Cloud Computing',
      courses: [
        'AWS Training',
        'Azure Training',
        'GCP Training',
        'Cloud Certification Training'
      ]
    },
    'devops': {
      name: 'DevOps',
      courses: [
        'DevOps Training',
        'Linux Training',
        'Git & GitHub Training',
        'CI/CD Jenkins Training',
        'Docker Training',
        'Kubernetes Training',
        'Terraform Training',
        'Ansible Training',
        'DevSecOps Training',
        'Monitoring & Observability Training'
      ]
    },
    'web-development': {
      name: 'Web Development',
      courses: [
        'React Training',
        'MERN Full-Stack Training',
        'Java Full-Stack Training',
        'Python Full-Stack Training',
        'DOT NET Full-Stack Training'
      ]
    },
    'programming': {
      name: 'Programming',
      courses: [
        'Java Programming',
        'Python Programming',
        'JavaScript Programming',
        'C Programming',
        'C++ Programming',
        'Advanced Python Training',
        'Python with Django Training',
        'Python with Flask Training'
      ]
    },
    'data-engineering': {
      name: 'Data Engineering',
      courses: [
        'Data Engineering Training',
        'Big Data Training',
        'Cloud Data Engineering Training'
      ]
    },
    'testing-addons': {
      name: 'Testing Add-ons',
      courses: [
        'ISTQB Certification Training',
        'SQL for Testers',
        'API Security Testing',
        'Automation Framework Design Training'
      ]
    },
    'power-platform': {
      name: 'Power Platform',
      courses: [
        'Power Apps Training',
        'Power Automate Training',
        'Power BI Training'
      ]
    },
    'mobile-development': {
      name: 'Mobile Development',
      courses: [
        'React Native Training',
        'Flutter Training',
        'Android App Development (Basics)'
      ]
    },
    'ui-ux': {
      name: 'UI/UX Design',
      courses: [
        'UI/UX Design Training',
        'Figma Design Training'
      ]
    }
  };

  const handleCourseClick = (course) => {
    setIsCoursesDropdownOpen(false);
    if (isMobileMenuOpen) {
      toggleMobileMenu();
    }
    if (onCourseSelect) {
      onCourseSelect(course);
    }
  };

  const toggleMobileMenu = () => {
    const currentScroll = window.scrollY;
    setIsMobileMenuOpen(prev => !prev);
    setIsCoursesDropdownOpen(false);
    setSelectedMobileCategory(null);
    setTimeout(() => window.scrollTo(0, currentScroll), 0);
  };

  return (
    <>
      <style>{`
        .sticky-header-container {
          position: sticky;
          top: 0;
          z-index: 10000;
        }
        
        .header-sticky-wrapper {
          position: relative;
        }

        .promo-banner {
          background: linear-gradient(135deg, #ea580c 0%, #f97316 50%, #fb923c 100%);
          color: white;
          padding: 6px 0;
          font-size: 17px;
          font-weight: 600;
          text-align: center;
          position: relative;
        }

        @media (max-width: 768px) {
          .promo-banner {
            padding: 5px 8px;
            font-size: 12px;
            font-weight: 600;
            white-space: nowrap;
            overflow: hidden;
          }
        }

        .top-contact-strip {
          background: #0a1628;
          color: white;
          padding: 10px 0;
          font-size: 16px;
          position: relative;
        }

        .top-contact-container {
          max-width: 1400px;
          margin: 0 auto;
          padding: 0 40px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .top-contact-left {
          display: flex;
          gap: 20px;
          align-items: center;
        }

        .top-contact-right {
          display: flex;
          gap: 20px;
          align-items: center;
        }

        .top-contact-item {
          display: flex;
          align-items: center;
          padding: 0 20px;
          border-right: 1px solid rgba(255, 255, 255, 0.3);
        }

        .top-contact-item:last-child {
          border-right: none;
        }

        .top-contact-item a {
          color: white;
          text-decoration: none;
          transition: opacity 0.2s ease;
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .top-contact-item a:hover {
          opacity: 0.8;
        }

        @keyframes blinkPop {
          0%, 100% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.3); opacity: 0.7; }
        }

        .contact-icon {
          animation: blinkPop 1.5s ease-in-out infinite;
        }

        .social-links {
          display: flex;
          gap: 15px;
        }

        .social-link {
          color: white;
          font-size: 18px;
          transition: all 0.3s ease;
          text-decoration: none;
          display: inline-flex;
          align-items: center;
          justify-content: center;
        }

        .social-link:hover {
          transform: translateY(-2px) scale(1.1);
          opacity: 0.8;
        }

        .social-link svg {
          width: 18px;
          height: 18px;
          fill: white;
        }

        @keyframes scrollContent {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }

        @media (max-width: 768px) {
          .top-contact-strip {
            padding: 8px 0;
            overflow: hidden;
          }

          .top-contact-container {
            display: inline-flex;
            padding: 0;
            white-space: nowrap;
            animation: scrollContent 25s linear infinite;
            gap: 0;
          }

          .top-contact-left,
          .top-contact-right {
            display: inline-flex;
            gap: 0;
            align-items: center;
          }

          .top-contact-left-duplicate,
          .top-contact-right-duplicate {
            display: inline-flex;
            gap: 0;
            align-items: center;
          }

          .top-contact-item {
            padding: 0 15px;
            border-right: 1px solid rgba(255, 255, 255, 0.3);
            font-size: 13px;
            white-space: nowrap;
          }

          .top-contact-item:first-child {
            padding-left: 20px;
          }

          .top-contact-item a {
            white-space: nowrap;
          }

          .social-links {
            padding: 0 15px;
            border-right: 1px solid rgba(255, 255, 255, 0.3);
          }

          .social-link {
            font-size: 16px;
          }
        }

        @media (min-width: 769px) {
          .top-contact-left-duplicate,
          .top-contact-right-duplicate {
            display: none;
          }
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        @keyframes slideInRight {
          from {
            transform: translateX(100%);
          }
          to {
            transform: translateX(0);
          }
        }

        @keyframes slideFromTopRight {
          from {
            transform: translate(100%, -100%) scale(0.8);
            opacity: 0;
          }
          to {
            transform: translate(0, 0) scale(1);
            opacity: 1;
          }
        }

        .header-nav-link {
          position: relative;
          color: #000000;
          font-weight: 600;
          font-size: 15px;
          transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          padding: 8px 0;
        }

        .header-nav-link:hover {
          color: #000000;
          transform: translateY(-1px);
        }

        .header-nav-link::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          width: 0;
          height: 3px;
          background: linear-gradient(90deg, #ff6b35 0%, #ffa500 50%, #ff8c42 100%);
          background-size: 200% 100%;
          transition: width 0.3s ease;
          animation: gradientMove 3s linear infinite;
        }

        .header-nav-link:hover::after {
          width: 100%;
        }

        .header-nav-link.active {
          color: #000000;
        }

        .header-nav-link.active::after {
          width: 100%;
        }

        @keyframes gradientMove {
          0% { background-position: 0% 50%; }
          100% { background-position: 200% 50%; }
        }

        .courses-dropdown {
          position: absolute;
          top: 100%;
          left: 0;
          background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(59, 130, 246, 0.1);
          border-radius: 12px;
          padding: 4px;
          min-width: 280px;
          max-width: 300px;
          height: 450px;
          margin-top: 8px;
          z-index: 10000;
          border: 1px solid rgba(59, 130, 246, 0.15);
          overflow-y: auto;
        }

        @media (min-width: 1025px) and (max-width: 1440px) {
          .courses-dropdown {
            height: auto !important;
            max-height: 65vh !important;
            padding: 3px !important;
          }
          .category-item {
            padding: 3px 8px !important;
            font-size: 13px !important;
            margin-bottom: 1px !important;
          }
          .category-subdropdown {
            height: 65vh !important;
            max-height: 65vh !important;
            padding: 8px !important;
            width: 260px !important;
            left: -262px !important;
            overflow-y: auto !important;
            overflow-x: hidden !important;
          }
          .category-subdropdown h4 {
            font-size: 11px !important;
            margin-bottom: 4px !important;
          }
          .category-subdropdown ul li a {
            padding: 3px 8px !important;
            font-size: 12px !important;
          }
        }

        .category-item {
          position: relative;
          padding: 4px 10px;
          cursor: pointer;
          border-radius: 6px;
          font-size: 15px;
          font-weight: 600;
          color: #1f2937;
          background: white;
          margin-bottom: 2px;
          border: 1px solid transparent;
        }

        .category-item:hover {
          background: white;
          color: #1f2937;
          border-color: transparent;
        }

        .category-item::before {
          content: '';
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 3px;
          height: 0;
          background: linear-gradient(180deg, #ff6b35, #ffa500);
          border-radius: 0 3px 3px 0;
        }

        .category-subdropdown {
          position: absolute;
          top: calc(100% + 8px);
          left: -280px;
          margin-top: 0;
          background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(59, 130, 246, 0.1);
          border-radius: 12px;
          padding: 12px;
          width: 280px;
          height: 450px;
          z-index: 10001;
          opacity: 0;
          visibility: hidden;
          pointer-events: none;
          border: 1px solid rgba(59, 130, 246, 0.15);
        }


        
        .category-subdropdown::before {
          content: '';
          position: absolute;
          top: 0;
          right: -20px;
          width: 25px;
          height: 100%;
          background: transparent;
        }

        .category-item:nth-last-child(-n+4) .category-subdropdown {
          bottom: 0;
          top: auto;
        }

        .mobile-menu-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.7);
          z-index: 9999999999998;
          opacity: 0;
          animation: fadeIn 0.3s ease forwards;
          backdrop-filter: blur(4px);
          -webkit-tap-highlight-color: transparent;
          touch-action: none;
          overscroll-behavior: contain;
        }

        .mobile-menu {
          position: fixed;
          top: 0;
          right: 0;
          height: 100vh;
          height: 100dvh;
          width: 70%;
          max-width: 350px;
          background: linear-gradient(180deg, #0a1628 0%, #0d1b2a 50%, #1b263b 100%);
          z-index: 9999999999999;
          overflow-y: auto;
          overflow-x: hidden;
          -webkit-overflow-scrolling: touch;
          overscroll-behavior: contain;
          transform-origin: top right;
          animation: slideFromTopRight 0.4s cubic-bezier(0.4, 0, 0.2, 1) forwards;
          box-shadow: -8px 0 32px rgba(0, 0, 0, 0.5);
        }

        .mobile-menu::-webkit-scrollbar {
          width: 6px;
        }

        .mobile-menu::-webkit-scrollbar-track {
          background: rgba(255, 255, 255, 0.05);
        }

        .mobile-menu::-webkit-scrollbar-thumb {
          background: rgba(255, 255, 255, 0.2);
          border-radius: 3px;
        }

        .mobile-menu::-webkit-scrollbar-thumb:hover {
          background: rgba(255, 255, 255, 0.3);
        }

        .hamburger {
          display: none;
          flex-direction: column;
          gap: 5px;
          cursor: pointer;
          padding: 8px;
          z-index: 10;
          position: relative;
          background: transparent;
          border: none;
          outline: none;
          -webkit-tap-highlight-color: transparent;
        }

        .hamburger span {
          width: 25px;
          height: 3px;
          background: #1f2937;
          border-radius: 2px;
          transition: all 0.3s ease;
          display: block;
        }

        .hamburger.open span:nth-child(1) {
          transform: rotate(45deg) translate(8px, 8px);
        }

        .hamburger.open span:nth-child(2) {
          opacity: 0;
        }

        .hamburger.open span:nth-child(3) {
          transform: rotate(-45deg) translate(7px, -7px);
        }

        @media (max-width: 1024px) {
          .desktop-nav {
            display: none !important;
          }
          .hamburger {
            display: flex !important;
          }
          .mobile-logo {
            height: 39px !important;
            margin-left: -20px !important;
          }
        }

        @media (max-width: 768px) {
          header {
            top: 0 !important;
          }
        }

        @media (max-width: 768px) {
          .courses-dropdown {
            min-width: 280px;
            max-width: 320px;
          }
          .category-subdropdown {
            min-width: 280px;
            max-width: 320px;
          }
        }
      `}</style>

      <div className="sticky-header-container">
      {/* Top Contact Strip */}
      <div className="top-contact-strip">
        <div className="top-contact-container">
            <div className="top-contact-left">
              <div className="social-links">
                <a href="https://www.facebook.com/OraniumTech/" target="_blank" rel="noopener noreferrer" className="social-link" title="Facebook">
                  <svg viewBox="0 0 24 24">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                  </svg>
                </a>
                <a href="https://www.instagram.com/oraniumtechofficial/?hl=en" target="_blank" rel="noopener noreferrer" className="social-link" title="Instagram">
                  <svg viewBox="0 0 24 24">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                  </svg>
                </a>
                <a href="https://in.linkedin.com/company/oraniumtech" target="_blank" rel="noopener noreferrer" className="social-link" title="LinkedIn">
                  <svg viewBox="0 0 24 24">
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                  </svg>
                </a>
                <a href="https://x.com/oraniumtech" target="_blank" rel="noopener noreferrer" className="social-link" title="X (Twitter)">
                  <svg viewBox="0 0 24 24">
                    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                  </svg>
                </a>
              </div>
            </div>
            <div className="top-contact-right">
              <div className="top-contact-item">
                <a href="tel:+917871719161">
                  <svg className="contact-icon" width="16" height="16" viewBox="0 0 24 24" fill="white">
                    <path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56-.35-.12-.74-.03-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z"/>
                  </svg>
                  Chrompet / Velachery:  +91 78717 19161
                </a>
              </div>
              <div className="top-contact-item">
                <a href="mailto:oraniumtech@gmail.com">
                  <svg className="contact-icon" width="16" height="16" viewBox="0 0 24 24" fill="white">
                    <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                  </svg>
                  oraniumtech@gmail.com
                </a>
              </div>
            </div>
            <div className="top-contact-left-duplicate">
              <div className="social-links">
                <a href="https://www.facebook.com/OraniumTech/" target="_blank" rel="noopener noreferrer" className="social-link" title="Facebook">
                  <svg viewBox="0 0 24 24">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                  </svg>
                </a>
                <a href="https://www.instagram.com/oraniumtechofficial/?hl=en" target="_blank" rel="noopener noreferrer" className="social-link" title="Instagram">
                  <svg viewBox="0 0 24 24">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                  </svg>
                </a>
                <a href="https://in.linkedin.com/company/oraniumtech" target="_blank" rel="noopener noreferrer" className="social-link" title="LinkedIn">
                  <svg viewBox="0 0 24 24">
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                  </svg>
                </a>
                <a href="https://x.com/oraniumtech" target="_blank" rel="noopener noreferrer" className="social-link" title="X (Twitter)">
                  <svg viewBox="0 0 24 24">
                    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                  </svg>
                </a>
              </div>
            </div>
            <div className="top-contact-right-duplicate">
              <div className="top-contact-item">
                <a href="tel:+917871719161">
                  <svg className="contact-icon" width="16" height="16" viewBox="0 0 24 24" fill="white">
                    <path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56-.35-.12-.74-.03-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z"/>
                  </svg>
                  Chrompet / Velachery:  +91 78717 19161
                </a>
              </div>
              <div className="top-contact-item">
                <a href="mailto:oraniumtech@gmail.com">
                  <svg className="contact-icon" width="16" height="16" viewBox="0 0 24 24" fill="white">
                    <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                  </svg>
                  oraniumtech@gmail.com
                </a>
              </div>
            </div>
          </div>
      </div>

      <div className={`header-sticky-wrapper ${activePage === 'home' ? 'sticky-home' : 'sticky-other'}`}>
        {/* Promo Banner */}
        {showPromoBanner && (
          <div className="promo-banner">
            {isMobile ? mobilePromoMessages[promoIndex] : promoMessages[promoIndex]}
          </div>
        )}

        <header style={{
          background: 'linear-gradient(180deg, #ffffff 0%, #f0f9ff 50%, #e0f2fe 100%)',
          boxShadow: '0 2px 12px rgba(59, 130, 246, 0.15), 0 4px 20px rgba(0, 0, 0, 0.05)',
          borderBottom: '1px solid rgba(59, 130, 246, 0.1)',
        }}>
        <div style={{
          maxWidth: '1400px',
          margin: '0 auto',
          padding: '0 10px 0 24px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          height: '85px',
        }}>
          {/* Logo */}
          <div onClick={(e) => {
            e.preventDefault();
            onHomeClick();
          }} style={{
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
          }}>
            <img src={logo} alt="Oranium Logo" className="mobile-logo" style={{
              height: '65px',
              width: 'auto',
            }} />
          </div>

          {/* Desktop Navigation */}
          <nav style={{
            display: 'flex',
            alignItems: 'center',
            gap: '32px',
            marginLeft: 'auto',
          }} className="desktop-nav">
              <a 
              href="#"
              onClick={(e) => {
                e.preventDefault();
                onHomeClick();
              }}
              className={`header-nav-link ${activePage === 'home' ? 'active' : ''}`}
              style={{ cursor: 'pointer' }}
            >
              Home
            </a>            {/* Courses Dropdown */}
            <div 
              style={{ position: 'relative' }}
              onMouseEnter={() => {
                if (dropdownCloseTimer.current) {
                  clearTimeout(dropdownCloseTimer.current);
                }
                setIsCoursesDropdownOpen(true);
                if (window.Tawk_API?.hideWidget) window.Tawk_API.hideWidget();
              }}
              onMouseLeave={() => {
                dropdownCloseTimer.current = setTimeout(() => {
                  setIsCoursesDropdownOpen(false);
                  if (window.Tawk_API?.showWidget) window.Tawk_API.showWidget();
                }, 100);
              }}
            >
              <a href="#" className={`header-nav-link ${activePage === 'courses' || activePage === 'course-details' ? 'active' : ''}`} style={{ cursor: 'pointer' }} onClick={(e) => e.preventDefault()}>
                Courses
              </a>

              {isCoursesDropdownOpen && (
                <div className="courses-dropdown">
                  {Object.entries(courseCategories).map(([key, category]) => (
                    <div 
                      key={key}
                      className="category-item"
                      onMouseEnter={() => setSelectedCategory(key)}
                    >
                      {category.name}
                    </div>
                  ))}
                </div>
              )}

              {selectedCategory && (
                <div className="category-subdropdown" style={{ opacity: 1, visibility: 'visible', pointerEvents: 'auto' }}>
                  <h4 style={{
                    fontSize: '13px',
                    fontWeight: '700',
                    color: '#1e3a8a',
                    marginBottom: '6px',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    paddingLeft: '4px',
                    marginTop: '0',
                  }}>
                    {courseCategories[selectedCategory].name}
                  </h4>
                  <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                    {courseCategories[selectedCategory].courses.map((course, idx) => (
                      <li key={idx}>
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            handleCourseClick(course);
                          }}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px',
                            padding: '4px 10px',
                            fontSize: '13.5px',
                            fontWeight: '500',
                            color: '#4b5563',
                            cursor: 'pointer',
                            borderRadius: '6px',
                            backgroundColor: selectedCourse === course ? 'linear-gradient(135deg, #fff7ed 0%, #ffedd5 100%)' : 'white',
                            marginBottom: '1px',
                            border: '1px solid transparent',
                          }}
                        >
                          {course}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>

            <a 
              href="#"
              onClick={(e) => {
                e.preventDefault();
                onAboutClick();
              }}
              className={`header-nav-link ${activePage === 'about' ? 'active' : ''}`}
              style={{ cursor: 'pointer' }}
            >
              About Us
            </a>
            <a 
              href="#"
              onClick={(e) => {
                e.preventDefault();
                onContactClick();
              }}
              className={`header-nav-link ${activePage === 'contact' ? 'active' : ''}`}
              style={{ cursor: 'pointer' }}
            >
              Contact Us
            </a>
            {/* Enroll Button */}
            <button
              onClick={onEnrollClick}
              style={{
                padding: '12px 28px',
                background: 'linear-gradient(135deg, #1e3a8a 0%, #2563eb 50%, #3b82f6 100%)',
                color: 'white',
                border: 'none',
                borderRadius: '30px',
                fontWeight: '600',
                fontSize: '14px',
                cursor: 'pointer',
                boxShadow: '0 4px 12px rgba(37, 99, 235, 0.5)',
                transition: 'all 0.3s ease',
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 6px 20px rgba(37, 99, 235, 0.6)';
                e.target.style.background = 'linear-gradient(135deg, #1e40af 0%, #2563eb 50%, #3b82f6 100%)';
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 4px 12px rgba(37, 99, 235, 0.5)';
                e.target.style.background = 'linear-gradient(135deg, #1e3a8a 0%, #2563eb 50%, #3b82f6 100%)';
              }}
            >
              Enroll Now
            </button>
          </nav>

          {/* Mobile Hamburger */}
          <div 
            className={`hamburger ${isMobileMenuOpen ? 'open' : ''}`}
            onClick={toggleMobileMenu}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
        </header>
      </div>
      </div>

      {/* Mobile Menu - Rendered via Portal */}
      {isMobileMenuOpen && ReactDOM.createPortal(
        <React.Fragment>
          <div 
            className="mobile-menu-overlay" 
            onClick={toggleMobileMenu}
            onTouchMove={(e) => e.preventDefault()}
            onWheel={(e) => e.preventDefault()}
          ></div>
          <div 
            className="mobile-menu"
            onTouchMove={(e) => e.stopPropagation()}
          >
              <div style={{ padding: '12px', display: 'flex', flexDirection: 'column', height: '100%' }}>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'flex-end',
                  marginBottom: '10px',
                  paddingBottom: '8px',
                  borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                }}>
                  <button
                    onClick={toggleMobileMenu}
                    style={{
                      background: 'rgba(255, 255, 255, 0.1)',
                      border: '1px solid rgba(255, 255, 255, 0.2)',
                      fontSize: '28px',
                      cursor: 'pointer',
                      color: 'white',
                      padding: '4px 10px',
                      lineHeight: 1,
                      borderRadius: '8px',
                      transition: 'all 0.3s ease',
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.background = 'rgba(255, 255, 255, 0.2)';
                      e.target.style.transform = 'rotate(90deg)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.background = 'rgba(255, 255, 255, 0.1)';
                      e.target.style.transform = 'rotate(0deg)';
                    }}
                  >
                    ×
                  </button>
                </div>

                <nav style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex: 1 }}>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      onHomeClick();
                      toggleMobileMenu();
                    }}
                    style={{
                      padding: '8px 12px',
                      fontSize: '15px',
                      fontWeight: '600',
                      color: 'rgba(255, 255, 255, 0.9)',
                      cursor: 'pointer',
                      borderRadius: '10px',
                      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                      background: activePage === 'home' ? 'rgba(59, 130, 246, 0.2)' : 'transparent',
                      border: '1px solid transparent',
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.background = 'rgba(59, 130, 246, 0.15)';
                      e.target.style.borderColor = 'rgba(59, 130, 246, 0.3)';
                      e.target.style.transform = 'translateX(5px)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.background = activePage === 'home' ? 'rgba(59, 130, 246, 0.2)' : 'transparent';
                      e.target.style.borderColor = 'transparent';
                      e.target.style.transform = 'translateX(0)';
                    }}
                  >
                    Home
                  </a>

                  {/* Mobile Courses */}
                  <div>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        setIsCoursesDropdownOpen(!isCoursesDropdownOpen);
                      }}
                      style={{
                        padding: '8px 12px',
                        fontSize: '15px',
                        fontWeight: '600',
                        color: 'rgba(255, 255, 255, 0.9)',
                        cursor: 'pointer',
                        borderRadius: '10px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                        background: isCoursesDropdownOpen ? 'rgba(59, 130, 246, 0.2)' : 'transparent',
                        border: '1px solid transparent',
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = 'rgba(59, 130, 246, 0.15)';
                        e.currentTarget.style.borderColor = 'rgba(59, 130, 246, 0.3)';
                        e.currentTarget.style.transform = 'translateX(5px)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = isCoursesDropdownOpen ? 'rgba(59, 130, 246, 0.2)' : 'transparent';
                        e.currentTarget.style.borderColor = 'transparent';
                        e.currentTarget.style.transform = 'translateX(0)';
                      }}
                    >
                      Courses
                      <span style={{
                        transform: isCoursesDropdownOpen ? 'rotate(180deg)' : 'rotate(0)',
                        transition: 'transform 0.3s ease',
                      }}>▼</span>
                    </a>

                    {isCoursesDropdownOpen && (
                      <div style={{ paddingLeft: '8px', marginTop: '4px' }}>
                        {!selectedMobileCategory ? (
                          // Show categories
                          Object.entries(courseCategories).map(([key, category]) => (
                            <div
                              key={key}
                              onClick={() => setSelectedMobileCategory(key)}
                              style={{
                                padding: '6px 10px',
                                marginBottom: '4px',
                                fontSize: '12.5px',
                                fontWeight: '600',
                                color: 'rgba(255, 255, 255, 0.85)',
                                cursor: 'pointer',
                                borderRadius: '8px',
                                backgroundColor: 'rgba(255, 255, 255, 0.05)',
                                border: '1px solid rgba(255, 255, 255, 0.1)',
                              }}
                            >
                              {category.name}
                              <span style={{ float: 'right', color: 'rgba(59, 130, 246, 0.8)' }}>→</span>
                            </div>
                          ))
                        ) : (
                          // Show courses for selected category
                          <div>
                            <div
                              onClick={() => setSelectedMobileCategory(null)}
                              style={{
                                padding: '6px 10px',
                                marginBottom: '6px',
                                fontSize: '12.5px',
                                fontWeight: '600',
                                color: 'rgba(59, 130, 246, 0.9)',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px',
                                transition: 'all 0.3s ease',
                              }}
                              onMouseEnter={(e) => e.target.style.transform = 'translateX(-5px)'}
                              onMouseLeave={(e) => e.target.style.transform = 'translateX(0)'}
                            >
                              <span>←</span> Back to Categories
                            </div>
                            <h4 style={{
                              fontSize: '10px',
                              fontWeight: '700',
                              color: 'rgba(255, 255, 255, 0.6)',
                              marginBottom: '6px',
                              textTransform: 'uppercase',
                              paddingLeft: '10px',
                            }}>
                              {courseCategories[selectedMobileCategory].name}
                            </h4>
                            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                              {courseCategories[selectedMobileCategory].courses.map((course, idx) => (
                                <li key={idx}>
                                  <a
                                    href="#"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      handleCourseClick(course);
                                    }}
                                    style={{
                                      display: 'block',
                                      padding: '5px 10px',
                                      fontSize: '11.5px',
                                      color: selectedCourse === course ? 'rgba(59, 130, 246, 0.95)' : 'rgba(255, 255, 255, 0.75)',
                                      cursor: 'pointer',
                                      borderRadius: '6px',
                                      marginBottom: '2px',
                                      backgroundColor: selectedCourse === course ? 'rgba(59, 130, 246, 0.15)' : 'transparent',
                                      fontWeight: selectedCourse === course ? '600' : '400',
                                      border: '1px solid transparent',
                                    }}
                                  >
                                    {course}
                                  </a>
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}
                      </div>
                    )}
                  </div>

                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      onAboutClick();
                      toggleMobileMenu();
                    }}
                    style={{
                      padding: '8px 12px',
                      fontSize: '15px',
                      fontWeight: '600',
                      color: 'rgba(255, 255, 255, 0.9)',
                      cursor: 'pointer',
                      borderRadius: '10px',
                      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                      background: activePage === 'about' ? 'rgba(59, 130, 246, 0.2)' : 'transparent',
                      border: '1px solid transparent',
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.background = 'rgba(59, 130, 246, 0.15)';
                      e.target.style.borderColor = 'rgba(59, 130, 246, 0.3)';
                      e.target.style.transform = 'translateX(5px)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.background = activePage === 'about' ? 'rgba(59, 130, 246, 0.2)' : 'transparent';
                      e.target.style.borderColor = 'transparent';
                      e.target.style.transform = 'translateX(0)';
                    }}
                  >
                    About Us
                  </a>

                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      onContactClick();
                      toggleMobileMenu();
                    }}
                    style={{
                      padding: '8px 12px',
                      fontSize: '15px',
                      fontWeight: '600',
                      color: 'rgba(255, 255, 255, 0.9)',
                      cursor: 'pointer',
                      borderRadius: '10px',
                      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                      background: activePage === 'contact' ? 'rgba(59, 130, 246, 0.2)' : 'transparent',
                      border: '1px solid transparent',
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.background = 'rgba(59, 130, 246, 0.15)';
                      e.target.style.borderColor = 'rgba(59, 130, 246, 0.3)';
                      e.target.style.transform = 'translateX(5px)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.background = activePage === 'contact' ? 'rgba(59, 130, 246, 0.2)' : 'transparent';
                      e.target.style.borderColor = 'transparent';
                      e.target.style.transform = 'translateX(0)';
                    }}
                  >
                    Contact Us
                  </a>

                  <button
                    onClick={() => {
                      onEnrollClick();
                      toggleMobileMenu();
                    }}
                    style={{
                      width: '100%',
                      padding: '9px 18px',
                      marginTop: '4px',
                      background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 50%, #1d4ed8 100%)',
                      color: 'white',
                      border: 'none',
                      borderRadius: '10px',
                      fontWeight: '600',
                      fontSize: '14px',
                      cursor: 'pointer',
                      boxShadow: '0 6px 20px rgba(59, 130, 246, 0.4)',
                      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.transform = 'translateY(-2px)';
                      e.target.style.boxShadow = '0 8px 24px rgba(59, 130, 246, 0.5)';
                      e.target.style.background = 'linear-gradient(135deg, #2563eb 0%, #1d4ed8 50%, #1e40af 100%)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.transform = 'translateY(0)';
                      e.target.style.boxShadow = '0 6px 20px rgba(59, 130, 246, 0.4)';
                      e.target.style.background = 'linear-gradient(135deg, #3b82f6 0%, #2563eb 50%, #1d4ed8 100%)';
                    }}
                  >
                    Enroll Now
                  </button>

                </nav>

                <div style={{ marginTop: 'auto', paddingTop: '12px', borderTop: '1px solid rgba(255, 255, 255, 0.1)' }}>
                </div>
              </div>
            </div>
        </React.Fragment>,
        document.body
      )}
    </>
  );
};

export default Header;
